import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { Form } from "./Form";
import { Table } from "./Table";
import { IPermissionProps } from "../../../../models/Login";

export const TrainnerSelectionModule = (permission: IPermissionProps) => {
    const [modal, setModal] = useState({ open: false } as { open: boolean });
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const reloadTable = () => setReload(!reload);
    return (
        <>
            {(permission.is_Create || permission.is_Update) && <Form open={modal.open} hideDialog={() => setModal({ open: false })} toast={toast} reloadTable={reloadTable} />}
            <Table reload={reload} setModal={setModal} permission={permission} toast={toast} />
            <Toast ref={toast} />
        </>
    );
}